import { render, staticRenderFns } from "./WarehouseDashboard.vue?vue&type=template&id=3a4f6df9&"
import script from "./WarehouseDashboard.vue?vue&type=script&lang=js&"
export * from "./WarehouseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports